import { render, staticRenderFns } from "./PBRInterfaceShow.vue?vue&type=template&id=d5376254&"
import script from "./PBRInterfaceShow.vue?vue&type=script&lang=js&"
export * from "./PBRInterfaceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports